type IconDribbbleProps = {
    className?: string;
};

export function IconDribbble(props: IconDribbbleProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0.703125C5.37528 0.703125 0 6.0784 0 12.7031C0 19.3278 5.37528 24.7031 12 24.7031C18.6117 24.7031 24 19.3278 24 12.7031C24 6.0784 18.6117 0.703125 12 0.703125ZM19.9262 6.23457C21.3579 7.9786 22.2169 10.2042 22.243 12.612C21.9046 12.5469 18.5206 11.8571 15.1106 12.2866C15.0325 12.1175 14.9675 11.9352 14.8894 11.753C14.6811 11.2584 14.4468 10.7508 14.2126 10.2693C17.987 8.7335 19.705 6.52092 19.9262 6.23457ZM12 2.47319C14.603 2.47319 16.9848 3.44933 18.7939 5.0502C18.6117 5.3105 17.0629 7.37993 13.4187 8.74651C11.7397 5.66191 9.87852 3.13697 9.5922 2.74651C10.3601 2.5643 11.167 2.47319 12 2.47319ZM7.63992 3.43632C7.91323 3.80073 9.73536 6.33871 11.4403 9.35822C6.65076 10.6337 2.42083 10.6077 1.96529 10.6077C2.62906 7.43198 4.77658 4.78989 7.63992 3.43632ZM1.74403 12.7161C1.74403 12.612 1.74403 12.5079 1.74403 12.4038C2.18655 12.4168 7.15836 12.4819 12.2733 10.9461C12.5727 11.5187 12.846 12.1044 13.1063 12.6901C12.9761 12.7292 12.833 12.7682 12.7028 12.8072C7.41866 14.5122 4.60738 19.1717 4.37311 19.5621C2.7462 17.753 1.74403 15.3452 1.74403 12.7161ZM12 22.9591C9.63125 22.9591 7.44468 22.1521 5.71366 20.7986C5.89589 20.4211 7.97832 16.4124 13.757 14.3951C13.7831 14.3821 13.7961 14.3821 13.8221 14.3691C15.2668 18.1044 15.8525 21.2411 16.0087 22.1391C14.7722 22.6727 13.4187 22.9591 12 22.9591ZM17.7137 21.2021C17.6095 20.5773 17.0629 17.5838 15.7224 13.9005C18.9371 13.3929 21.7484 14.2259 22.0998 14.343C21.6573 17.1934 20.0173 19.6532 17.7137 21.2021Z"
                fill="black"
            />
        </svg>
    );
}

export default IconDribbble;
